import React from 'react'

export const LoginLayout = ({ children }) => {
  return <main className='w-full flex flex-col justify-center items-center p-3'>{children}</main>
}
